module.exports = __webpack_public_path__ + "img/honor_bg3.0e74deca.png";